var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10975",
    "data-name": "Group 10975",
    transform: "translate(17833 21367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 24,
    height: 24,
    transform: "translate(-17833 -21367)",
    fill: "#e6e2e2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20719",
    "data-name": "Path 20719",
    d: "M1.293,18,4.44,14.853a22.107,22.107,0,0,1-4.1-4.607L0,9.707l.343-.538c.2-.3,4.846-7.462,10.843-7.462a9.368,9.368,0,0,1,4.887,1.512L19.293,0l1.414,1.414L14.573,7.548a4,4,0,0,1-5.525,5.525L2.707,19.414ZM2.4,9.707A21.027,21.027,0,0,0,5.863,13.43l1.824-1.824a4,4,0,0,1,5.419-5.419L14.613,4.68a7.114,7.114,0,0,0-3.426-.973C7.082,3.707,3.426,8.3,2.4,9.707Zm8.8,2a2,2,0,0,0,1.882-2.675L10.531,11.59A1.99,1.99,0,0,0,11.207,11.707Zm-2-2a2,2,0,0,0,.03.348l.477-.477a1,1,0,0,1-.42-.46A1.991,1.991,0,0,0,9.207,9.707Zm1.418-1.913a1,1,0,0,1,.46.415l.471-.471a2.008,2.008,0,0,0-.931.056ZM7.809,16.978l1.554-1.554a6.235,6.235,0,0,0,1.823.284c4.1,0,7.76-4.593,8.783-6a21.965,21.965,0,0,0-2.256-2.634l1.417-1.418a22.308,22.308,0,0,1,2.9,3.514l.343.538-.343.538a22.509,22.509,0,0,1-3.241,3.846c-2.542,2.4-5.1,3.616-7.6,3.616A8.608,8.608,0,0,1,7.809,16.978Z",
    transform: "translate(-17832.188 -21364.707)",
    fill: "#888a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffIcon);
export default __webpack_public_path__ + "static/media/VisibilityOffIcon.82a10a97ee9ceebf0af6308da20036bf.svg";
export { ForwardRef as ReactComponent };